import React from 'react'
import { formatJSON } from '../../utils';
import TopAlbum from '../TopAlbum';
import Banner from '../Banner';


export default function MediaBox({ storeInfo, bannerProps, from = 'merchant' }) {
    if (!Object.keys(storeInfo).length) return null;
    const extendColumn = from === 'merchant' ? storeInfo.extendColumn1 : storeInfo.extendColumn;
    const extendObj = formatJSON(extendColumn);
    const { albumId } = extendObj || {}

    return (
        <>
            {
                albumId ?
                    <TopAlbum albumId={albumId} storeInfo={storeInfo} />
                    :
                    <Banner {...bannerProps} storeInfo={storeInfo} />
            }
        </>
    )
}
